// extracted by mini-css-extract-plugin
export var anchor = "_4c-0";
export var discard = "_4c-4";
export var muiTooltipTooltip = "_4c-6";
export var notificationBar = "_4c-3";
export var saveButtonHoverSlotWrapper = "_4c-5";
export var show = "_4c-2";
export var spacer = "_4c-1";